import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import toggleFiltersOpen from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/ToggleFiltersOpen";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Filter from "@insite/mobius/Icons/Filter";
import Minus from "@insite/mobius/Icons/Minus";
import Plus from "@insite/mobius/Icons/Plus";
import surtoggleFiltersOpen from "@tSurya/Handlers/SurToggleFiltersOpen";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import CustomDataState from "@tSurya/Store/Data/CustomApplicationState/CustomDataState";
import SuryaPageThemeWrapper from "@tSurya/Utils/SuryaPageThemeWrapper";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        filtersOpen: state.SURData.surFilterDataStore
    };
};

const mapDispatchToProps = {
    surtoggleFiltersOpen,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ViewReturnFilterStyles {
    container?: GridContainerProps;
    emptyGridItem?: GridItemProps;
    toggleFilterGridItem?: GridItemProps;
    toggleFilterIcon?: IconPresentationProps;
    toggleFilterClickable?: ClickablePresentationProps;
    toggleFilter?: GridItemProps;
    filterText?: GridItemProps;
}

export const headerStyles: ViewReturnFilterStyles = {
    container: {
        css: css`
            background: rgb(248, 248, 248);
            padding: 10px 20px;
            border-radius: 3px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;
            border: 1px solid rgb(224, 224, 224) !important;
            cursor: pointer;
            white-space: nowrap;
        `,
    },
    filterText: {
        css: css`
            font-size: large;
            font-weight: bolder;
        `,
    },
    toggleFilter: {
        css: css`
            justify-Content: flex-end
        `,
    },
};
const styles = headerStyles;

const SurViewReturnFilter: FC<Props> = ({ surtoggleFiltersOpen,filtersOpen, id }) => {
    const [isPulsing, setIsPulsing] = useState(true);
    
    const handleClick = () => {
        setIsPulsing(prevState => !prevState);
        surtoggleFiltersOpen();
    };
    useEffect(() => {
        if(!filtersOpen.surfiltersOpen) {
            surtoggleFiltersOpen();

        }
    }, []);
    return (
        <SuryaPageThemeWrapper>
            <StyledWrapper {...styles.container} onClick={() => handleClick()}>
                <StyledWrapper {...styles.filterText}>Search Returns</StyledWrapper>
                <StyledWrapper {...styles.toggleFilter}>
                    {isPulsing ? <Icon src={Minus} size={14} /> : <Icon src={Plus} size={14} />}
                </StyledWrapper>
            </StyledWrapper>
        </SuryaPageThemeWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SurViewReturnFilter),
    definition: {
        group: "Basic",
        displayName: "SurViewReturnFilter",
    },
};

export default widgetModule;
